import Appdata from '@/mixins/appdata'
import FiscalDocsProviderTypeEnum from '@/api/Enums/FiscalDocsProviderTypeEnum'
import Auth from '@/mixins/auth'
import FiscalDocStatusEnum from '@/api/Enums/FiscalDocStatusEnum'
import FiscalDocTypeCodeEnum from '@/api/Enums/FiscalDocTypeCodeEnum'
import AadeStatusCodeEnum from '@/api/Enums/AadeStatusCodeEnum.js'

export default {
  mixins  : [Auth, Appdata],
  computed: {},
  methods : {
    canRetryReceipt(item) {
      return this.userCanViewFiscalDoc && this.appHasFiscalDocsProvider && this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD && !item.CanceledAt && !item.Mark && !this.receiptHasError(item)
    },

    canCancelReceipt(item) {
      const providerTypeConditions = (this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD && item.Mark) || (this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.LOCAL && !item.Mark)

      return this.cancel && this.userCanViewFiscalDoc && this.posUserCan('RECEIPTS', 'MANAGE') && this.appHasFiscalDocsProvider && !!providerTypeConditions && !!item.CanCancel && !this.userIsDelivery && !this.receiptHasError(item)
    },

    canConvertReceipt(item) {
      const providerTypeConditions = (this.appHasFiscalDocsProvider && this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD && item.Mark)

      return this.convert
        && this.userCanViewFiscalDoc
        && !this.userIsDelivery
        && providerTypeConditions
        && (item.InvoiceTypeCodeInternal === FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT || item.InvoiceTypeCodeInternal === FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT)
        && (
          (item.InvoiceTypeCodeInternal === FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT && this.appHasReceiptSaleDocEnabled && this.appHasInvoiceSaleDocEnabled)
          || (item.InvoiceTypeCodeInternal === FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT && this.appHasReceiptServiceDocEnabled && this.appHasInvoiceServiceDocEnabled)
        )
        && this.posUserCan('RECEIPTS', 'MANAGE')
        && !!item.CanCancel
        && !this.receiptHasError(item)
    },

    tableReceiptOrderNumber(receipt, orders) {
      const orderNumber = orders?.find(order => order.Timestamp === receipt?.Timestamp)?.OrderNumber || ''
      return orderNumber ? `#${orderNumber}` : ''
    },

    receiptTypeColor(receipt, text = false, icon = false) {
      let retval = 'grey'
      const typeCode = receipt?.InvoiceTypeCodeInternal || receipt?.InvoiceTypeCode || receipt?.TypeCodeInternal || receipt?.TypeCode || receipt || ''

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE) {
        retval = {
          base: 'blue darken-3',
          text: 'blue--text text--darken-3',
          icon: 'blue lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_SERVICE_INVOICE) {
        retval = {
          base: 'light-blue darken-3',
          text: 'light-blue--text text--darken-3',
          icon: 'light-blue lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1) {
        retval = {
          base: 'red',
          text: 'red--text',
          icon: 'red lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_2) {
        retval = {
          base: 'red',
          text: 'red--text',
          icon: 'red lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT) {
        retval = {
          base: 'green darken-2',
          text: 'green--text text--darken-2',
          icon: 'green lighten-4'

        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT) {
        retval = {
          base: 'light-green darken-2',
          text: 'light-green--text text--darken-2',
          icon: 'light-green lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT) {
        retval = {
          base: 'red',
          text: 'red--text',
          icon: 'red lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_RECEIPT_CASH_POS) {
        retval = {
          base: 'lime darken-3',
          text: 'lime--text text--darken-2',
          icon: 'lime lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS) {
        retval = {
          base: 'red',
          text: 'red--text',
          icon: 'red lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER) {
        retval = {
          base: 'blue-grey',
          text: 'blue-grey--text',
          icon: 'blue-grey lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_CANCEL) {
        retval = {
          base: 'red',
          text: 'red--text',
          icon: 'red lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_RETURN) {
        retval = {
          base: 'orange',
          text: 'orange--text',
          icon: 'orange lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_SUPPLY) {
        retval = {
          base: 'cyan darken-2',
          text: 'cyan--text text--darken-2',
          icon: 'cyan lighten-4'
        }
      }

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_USE) {
        retval = {
          base: 'cyan darken-4',
          text: 'cyan--text text--darken-4',
          icon: 'cyan lighten-4'
        }
      }

      return text ? retval.text : icon ? retval.icon : retval.base
    },

    receiptTypeIcon(receipt) {
      let retval = 'receipt'
      const typeCode = receipt?.InvoiceTypeCodeInternal || receipt?.InvoiceTypeCode || receipt?.TypeCodeInternal || receipt?.TypeCode || receipt || ''

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE) retval = 'mdi-invoice-text-outline'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_SERVICE_INVOICE) retval = 'mdi-invoice-text'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1) retval = 'mdi-invoice-text-remove-outline'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_2) retval = 'mdi-invoice-text-remove-outline'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT) retval = 'mdi-receipt-text-outline'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT) retval = 'mdi-receipt-text'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT) retval = 'mdi-receipt-text-remove-outline'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_RECEIPT_CASH_POS) retval = 'mdi-receipt-text'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_RECEIPT_RETURN_POS) retval = 'mdi-receipt-text-remove-outline'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER) retval = 'mdi-text-box-outline'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_CANCEL) retval = 'mdi-text-box-remove-outline'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_RETURN) retval = 'mdi-text-box-minus-outline'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_SUPPLY) retval = 'mdi-handshake'

      if (typeCode === FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_USE) retval = 'mdi-handshake'

      return retval
    },

    receiptStatus(receipt) {
      if (receipt?.CanceledAt) return this.$t('Receipt.Status.Canceled')
      const status = receipt?.DocumentStatus || ''

      if (this.receiptHasError(receipt)) return this.$t('Receipt.Status.Error')

      if (this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD) {
        if (status === FiscalDocStatusEnum.OPEN) return this.$t('Receipt.Status.Open')

        if (status === FiscalDocStatusEnum.CLOSED) return this.$t('Receipt.Status.Closed')

        if (status === FiscalDocStatusEnum.AWAITING) return this.$t('Receipt.Status.Closed')

        if (status === FiscalDocStatusEnum.TRANSMITTED || receipt?.Mark) return this.$t('Receipt.Status.Transmitted')

        if (status === FiscalDocStatusEnum.TRANSMISSION_FAILURE) return this.$t('Receipt.Status.Waiting')

        if (status === FiscalDocStatusEnum.CANCELED) return this.$t('Receipt.Status.Canceled')
      }

      if (receipt?.Id && this.appHasFiscalDocsProvider && this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.LOCAL) return this.$t('Receipt.Status.Issued')

      return this.$t('Receipt.Status.Waiting')
    },

    receiptHasError(receipt) {
      return !!receipt?.ErrorCode
    },

    receiptErrorCode(receipt) {
      return receipt?.ErrorCode || ''
    },

    receiptErrorTitle(receipt) {
      let retVal = this.receiptErrorCode(receipt)

      if (this.receiptErrorCode(receipt) === AadeStatusCodeEnum.SystemError) retVal = 'System Error'
      if (this.receiptErrorCode(receipt) === AadeStatusCodeEnum.TechnicalError) retVal = 'Technical Error'
      if (this.receiptErrorCode(receipt) === AadeStatusCodeEnum.ValidationError) retVal = 'Validation Error'
      if (this.receiptErrorCode(receipt) === AadeStatusCodeEnum.XMLSyntaxError) retVal = 'XML Syntax Error'

      return retVal.toLocaleUpperCase(this.$i18n.locale)
    },

    receiptErrors(receipt) {
      return receipt?.Errors || []
    }
  }
}
